export default "__VITE_ASSET__Dd7hNvO5__"